import { supabase } from '../api/supabase'

// #290 (simplified): user_roles.boxtop_owner_name is a plain text field an admin fills in
// directly (no separate boxtop_employees lookup table — that design was over-engineered and
// buggy in practice). Same chain used by sync-to-boxtrax's Owner field and Job Detail's
// Owner display.
export async function resolveBoxtopEmployeeName(userEmail: string | null): Promise<string> {
  if (!userEmail) return 'Unassigned'
  const { data: userRole } = await supabase.from('user_roles').select('boxtop_owner_name').eq('user_email', userEmail).maybeSingle()
  return userRole?.boxtop_owner_name || userEmail.split('@')[0] || 'Unassigned'
}

export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url; a.download = fileName; a.click()
  URL.revokeObjectURL(url)
}
